export default {
  loginHeader: {
    appName: "Ирис",

    languageTooltip: "Избирање на јазик",
    languages: {
      en: "Англиски",
      bg: "Бугарски",
      mk: "Македонски",
    },
  },

  loginForm: {
    title: "Ирис",
    subtitle: "Лабораториски информациски систем",
    description:
      "Оптимизирајте го вашиот лабораториски работен процес со сеопфатно следење на примероци, валидација во реално време и безбеден пристап за повеќе корисници. Изградено за ефикасност, дизајнирано за лабораториски професионалци.",
    loginButtonText: "Најава во Ирис",
  },
};
